import React from 'react';
import AdminMasterLayout from '../../../layouts/gcadmin/adminMasterLayout/AdminMasterLayout';
import AdminReviews from '../../../subsreens/gcadmin/reviews/AdminReviews';


const  Review= () => {
    return(
       <AdminMasterLayout>
        <AdminReviews></AdminReviews>
       </AdminMasterLayout>
    )
}

export default Review;